import imgNetworking from '../assets/generated/service-networking.png';
import imgNas from '../assets/generated/service-storage.png';
import imgRepairs from '../assets/generated/service-repairs.png';
import imgRecovery from '../assets/generated/service-recovery.png';
import imgCctv from '../assets/generated/service-security.png';
import imgAmc from '../assets/generated/service-amc.png';

const services = [
  {
    id: 'advanced-networking',
    title: 'Advanced Networking',
    category: 'Infrastructure',
    short: 'Smart office networks, structured cabling, switching, Wi-Fi, and firewall planning.',
    image: imgNetworking,
    description: `We design and build the digital backbone behind productive offices. From structured cabling and server racks to managed switches, VLANs, secure Wi-Fi, and firewall deployment, our networking work is focused on stability, speed, and long-term maintainability. Whether you are opening a new office or fixing an unreliable setup, we create infrastructure that feels professionally planned from day one.`,
    highlights: [
      'Structured cabling, rack organization, and clean switch deployment',
      'Wi-Fi planning for stable coverage across rooms, floors, and teams',
      'Secure firewall, VLAN, and remote access setup for growing businesses'
    ],
    idealFor: 'Businesses setting up a new office, expanding teams, or struggling with unstable connectivity.'
  },
  {
    id: 'nas-storage',
    title: 'NAS & Data Storage',
    category: 'Data Protection',
    short: 'Private storage systems, file sharing, backup automation, and safer data control.',
    image: imgNas,
    description: `We help businesses move from scattered files and risky ad-hoc backups to a more controlled storage environment. Our NAS and storage services cover hardware setup, backup automation, remote access, permissions, and day-to-day usability. The result is a storage system your team can actually rely on, with better protection against accidental loss and downtime.`,
    highlights: [
      'Centralized team storage with better file access and control',
      'Backup scheduling, RAID planning, and safer recovery readiness',
      'Private-cloud style access for office, remote, and hybrid workflows'
    ],
    idealFor: 'Teams that need stronger backup discipline, shared storage, and safer access to important files.'
  },
  {
    id: 'repairs',
    title: 'Computer & Laptop Repairs',
    category: 'Support',
    short: 'Professional diagnostics, hardware fixes, replacements, and business device recovery.',
    image: imgRepairs,
    description: `Hardware issues can quietly slow an entire business down. We provide practical repair support for desktops, laptops, and work devices, covering diagnostics, part replacement, board-level issues, performance problems, and power-related faults. Our repair process is focused on clarity, quick recovery, and making smart repair-versus-replace decisions for each case.`,
    highlights: [
      'Laptop and desktop diagnostics for recurring hardware issues',
      'Screen, keyboard, battery, hinge, and internal component repair support',
      'Clear recommendations based on urgency, cost, and device condition'
    ],
    idealFor: 'Companies and professionals who need dependable repair help without losing time to guesswork.'
  },
  {
    id: 'data-recovery',
    title: 'Data Recovery',
    category: 'Emergency Support',
    short: 'Recovery support for deleted, damaged, corrupt, or inaccessible business data.',
    image: imgRecovery,
    description: `When critical files disappear, every hour matters. We help recover data from damaged drives, failed storage devices, corrupted partitions, and accidental deletion scenarios with a careful, privacy-conscious process. Our focus is to maximize the chance of recovery while treating sensitive business files with the seriousness they deserve.`,
    highlights: [
      'Support for hard drives, SSDs, USB devices, and damaged storage media',
      'Recovery help for accidental deletion, corruption, and unreadable systems',
      'Careful handling for sensitive financial, operational, and client information'
    ],
    idealFor: 'Urgent cases where lost data is blocking operations, compliance, or customer delivery.'
  },
  {
    id: 'cctv-biometric',
    title: 'CCTV & Biometric Security',
    category: 'Security',
    short: 'Office surveillance, attendance, entry control, and modern site security systems.',
    image: imgCctv,
    description: `We install practical security systems that help businesses monitor premises, improve accountability, and control access more confidently. Our work includes CCTV deployment, remote monitoring setup, biometric attendance systems, and access-control planning for sensitive spaces. The goal is simple: stronger security without adding operational complexity.`,
    highlights: [
      'CCTV installation and monitoring setup for offices and commercial spaces',
      'Biometric attendance systems for staff management and reporting',
      'Access-control planning for entry points and restricted zones'
    ],
    idealFor: 'Offices, clinics, retail spaces, and operations teams that need better visibility and control.'
  },
  {
    id: 'sales-amc',
    title: 'Sales & Annual Maintenance',
    category: 'Managed Care',
    short: 'Procurement support, preventive care, upgrades, and reliable annual maintenance.',
    image: imgAmc,
    description: `Good IT support is not only about fixing breakdowns after they happen. We help businesses source the right systems, maintain them on schedule, and stay ahead of avoidable downtime through annual maintenance and preventive care. For many clients, this becomes the most valuable part of the relationship because it creates consistency, planning, and less disruption.`,
    highlights: [
      'Procurement support for desktops, laptops, printers, and networking gear',
      'Annual maintenance plans with preventive checks and priority support',
      'One support partner for upgrades, recurring care, and issue follow-through'
    ],
    idealFor: 'Businesses looking for a long-term IT partner instead of one-off reactive support.'
  }
];

export default services;
